export enum EstadoSolicitudCredito
{
    PendienteRevision = "Pendiente revisión",
    PendienteDocumentacion = "Pendiente documentación",
    Ofertada = "Ofertada",
    PendienteSeleccionOfertaUsuario = "Pendiente selección oferta usuario",
    FinalizadaConGanador = "Finalizada con ganador",
    FinalizadaSinGanador = "Finalizada sin ganador",
    CanceladaUsuario = "Cancelada usuario",
    Caducada = "Caducada"
}